import React, { useContext } from "react";
import Login from "../pages/auth/Login";
import Productos from "../pages/productos/Productos";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Middleware from "./Middleware";
import Home from "../pages/home/Home";
import { AuthContext } from "../context/AuthContextProvider";
import Navbar from "./Navbar";
import Sidebar from "./sidebar/Sidebar";
import { makeStyles } from "@material-ui/core";
import TiposIngredientes from "../pages/tipos-ingredientes/TiposIngredientes";
import Horarios from "../pages/horarios/Horarios";
import ReportesPedidos from "../pages/reportes/ReportesPedidos";
import ReportesCadetes from "../pages/reportes/ReportesCadetes";
import Configuraciones from "../pages/configuraciones/Configuraciones";
import PaymentCallback from "../pages/configuraciones/PaymentCallback";

const SIDEBAR_WIDTH = 250;
const SIDEBAR_MOBILE_WIDTH = 73;
const NAVBAR_HEIGHT = 64;

const useStyles = makeStyles((theme) => ({
  root: {},
  container: {
    display: "flex",
    paddingTop: NAVBAR_HEIGHT,
    minHeight: "100vh",
  },
  content: {
    flexGrow: 1,
    marginLeft: SIDEBAR_WIDTH,
    [theme.breakpoints.down("sm")]: {
      marginLeft: SIDEBAR_MOBILE_WIDTH,
    },
  },
  contentFull: {
    flexGrow: 1,
  },
  contentContainer: {
    marginTop: 60
  }
}));

const Router = () => {
  const classes = useStyles();
  const { authenticated, mounted, negocioActivo } = useContext(AuthContext);

  const isAuth = () => authenticated && negocioActivo;

  return (
    <div className={classes.root}>
      {isAuth() && <Navbar />}
      {mounted && (
        <BrowserRouter>
          <div className={[classes.container, isAuth() ? { paddingTop: 0 } : {}]}>
            {isAuth() && <Sidebar />}
            <main className={isAuth() ? classes.content : classes.contentFull}>
              <div className={classes.contentContainer}>
                <Switch>
                  <Middleware exact path="/" component={Home} />
                  <Middleware exact path="/home" component={Home} />
                  <Middleware exact path="/productos" component={Productos} />
                  <Middleware exact path="/tipos-ingredientes" component={TiposIngredientes} />
                  <Middleware exact path="/horarios" component={Horarios} />
                  <Middleware exact path="/reportes/pedidos" component={ReportesPedidos} />
                  <Middleware exact path="/reportes/cadetes" component={ReportesCadetes} />
                  <Middleware exact path="/configuraciones" component={Configuraciones} />
                  <Middleware
                    exact
                    path="/configuraciones/payment/callback"
                    component={PaymentCallback}
                  />
                  <Route exact path="/login" component={Login} />
                </Switch>
              </div>
            </main>
          </div>
        </BrowserRouter>
      )}
    </div>
  );
};

export default Router;
